import { useRef, useState, useEffect } from 'react';

const useObserveAnimation = (options, animateOnce) => {
    const containerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [animationClasses, setAnimationClasses] = useState({
        animateBack: 'hiddenBack',
        animateTop: 'hiddenTop',
        animateBottom: 'hiddenBottom',
        animateLeft: 'hiddenLeft',
        animateRight: 'hiddenRight'
    });

    const observerCallback = entries => {
        const [entry] = entries;
        setIsVisible(entry.isIntersecting);
    };

    useEffect(() => {
        if (isVisible) {
            setAnimationClasses({
                animateBack: 'hiddenBack showBack',
                animateTop: 'hiddenTop showTop',
                animateBottom: 'hiddenBottom showBottom',
                animateLeft: 'hiddenLeft showLeft',
                animateRight: 'hiddenRight showRight'
            });
        } else {
            if (animateOnce !== undefined && !animateOnce) {
                setAnimationClasses({
                    animateBack: 'hiddenBack',
                    animateTop: 'hiddenTop',
                    animateBottom: 'hiddenBottom',
                    animateLeft: 'hiddenLeft',
                    animateRight: 'hiddenRight'
                });
            }
        }
    }, [isVisible, animateOnce]);

    useEffect(() => {
        let observerRefVal = null;

        const observer = new IntersectionObserver(
            observerCallback,
            options || {
                root: null,
                rootMargin: '0px',
                threshold: 1.0
            }
        );
        if (containerRef.current) {
            observer.observe(containerRef.current);
            observerRefVal = containerRef.current;
        }

        return () => {
            if (observerRefVal) {
                observer.unobserve(observerRefVal);
            }
        };
    }, [containerRef, options]);

    return [containerRef, animationClasses];
};

export default useObserveAnimation;
